import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CustomRightPanelService {
  myOpportunities: PanelConfig = {
    links: [
      { text: 'All Opportunities', route: '/candidate/apprenticeship/opportunity' },
      { text: 'Applications', route: '/candidate/applications' },
      { text: 'Invitations', route: '/candidate/invitations' },
      { text: 'Recommended', route: '/candidate/apprenticeship/recommended', icon: 'sd sd-star-06' },
    ],
    heading: "My Opportunities",
    subHeading:
      "Find and apply for apprenticeships, view your applications, and manage invites from establishments",
  };

  courses: PanelConfig = {
    links: [
      { text: "Apprenticeship Courses", route: "/candidate/courses" },
      { text: "Technician Vocational", route: "/candidate/tech-vocation" },
    ],
    heading: "Courses",
    subHeading:
      "Explore available courses and download key documents for your vocational training",
  };

  myApprenticeships: PanelConfig = {
    links: [
      { text: "Contract", route: "/candidate/contracts" },
      { text: "Stipend", route: "/candidate/stipend" },
    ],
    heading: "My Apprenticeship",
    subHeading:
      "Access your apprenticeship contracts and track stipend details for active opportunities",
  };

  terminationRequest: PanelConfig = {
    links: [
      { text: "Raise Termination Request", route: "/candidate/raise-termination-request" },
      { text: "Termination Request Received", route: "/candidate/termination-request-received" },
      { text: "Termination Request Status", route: "/candidate/termination-request-status" },
    ],
    heading: "Termination Request",
    subHeading:
      "Access Termination Request",
  };

  assessement: PanelConfig = {
    links: [
      { text: "Designated", route: "/candidate/ac-dt" },
      { text: "Optional", route: "/candidate/assessment" },
      { text: "AITT Exam", route: "/candidate/ac-dt/aitt-exam" },
    ],
    heading: "Assessments",
    subHeading:
      "Apply for and view assessment details and check your AITT exam status",
  };

  certification: PanelConfig = {
    links: [
      { text: "Designated", route: "/candidate/ac-dt/certification-dt" },
      { text: "Optional", route: "/candidate/assessment/certification" },
    ],
    heading: "Certification",
    subHeading:
      "Download marksheets and certificates for completed apprenticeships",
  };

  AITTGrievance: PanelConfig = {
    heading: "AITT Grievance",
    subHeading:
      "Raise concerns or track grievance status related to AITT examinations",
  };
   ServiceRequest: PanelConfig = {
    heading: "Service Requests/Grievance",
    subHeading:
      "Raise concerns or track request status",
  };
  Testimonials: PanelConfig = {
    heading: "Testimonials",
    subHeading:
      "Submit a new testimonial for your journey",
  };

  constructor() {}
}

export interface PanelConfig {
  links?: LinkConfig[];
  heading: string;
  subHeading: string;
}

export interface LinkConfig {
  text: string;
  route: string;
  icon?: string;
}
